import { createRouter, createWebHistory } from 'vue-router'
import AppShell from './layouts/AppShell.vue'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Item from './views/Item.vue'
import Login from './views/Login.vue'
import Random from './views/Random.vue'
import Rankings from './views/Rankings.vue'
import Search from './views/Search.vue'
import Submit from './views/Submit.vue'
import Profile from './views/Profile.vue'
import Admin from './views/Admin.vue'
import RireDeTout from './views/RireDeTout.vue'
import NotFound from './views/NotFound.vue'
import { isAuthenticated, authState } from './auth'

const routes = [
  {
    path: '/',
    component: AppShell,
    children: [
      { path: '', name: 'home', component: Home },
      { path: 'aleatoire', name: 'random', component: Random },
      { path: 'classement', name: 'rankings', component: Rankings },
      { path: 'rechercher', name: 'search', component: Search },
      { path: 'proposer', name: 'submit', component: Submit, meta: { requiresAuth: true } },
      { path: 'profil', name: 'profile', component: Profile, meta: { requiresAuth: true } },
      { path: 'admin', name: 'admin', component: Admin, meta: { requiresStaff: true } },
      { path: 'peut-on-rire-de-tout', name: 'rire-de-tout', component: RireDeTout },
      { path: 'about', name: 'about', component: About },
      { path: 'login', name: 'login', component: Login },
      { path: 'item/:id', name: 'item', component: Item, props: true },
      { path: ':pathMatch(.*)*', name: 'not-found', component: NotFound },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    // Same page, only the query changed (e.g. "une autre" pinning ?j=<id>,
    // or search pagination ?page=N) — keep the scroll position instead of
    // yanking the user back to the top.
    if (to.path === from.path) return false
    return { top: 0 }
  },
})

// Route guard: protect authenticated and staff-only routes.
router.beforeEach((to) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.meta.requiresStaff) {
    const user = authState.user
    if (!user) return { name: 'login', query: { redirect: to.fullPath } }
    if (!user.isStaff) return { name: 'home' }
  }
  return true
})

export default router
